export enum BroadcastMessageType {
    PASSKEY_REGISTERED = 'passkey-registered',
    PASSKEY_REJECTED = 'passkey-rejected',
    // Playgame
    PLAYGAME_CONNECTED = 'playgame-connected',
    PLAYGAME_DISCONNECTED = 'playgame-disconnected',
    PLAYGAME_START_GAME = 'playgame-start-game',
    PLAYGAME_DEPOSIT_SUCCESSFUL = 'playgame-deposit-successful',
    GAME_TILE_STOP_LOADING = 'game-tile-stop-loading',
}

export type BroadcastMessageTypeUnion = `${BroadcastMessageType}`

export type PlaygameStartGameData = {
    /**
     * Game slug to start
     */
    start: string
    gameInstanceId?: string
    tickets?: string
    provider?: string
    brand: string
}

export type BroadcastMessage = {
    type: BroadcastMessageType.PLAYGAME_START_GAME
    data: PlaygameStartGameData
} | {
    type: Exclude<BroadcastMessageType, BroadcastMessageType.PLAYGAME_START_GAME>
    data?: any
}
